import React from "react";
import { Row, Col } from "antd";
import styles from "./ThreeComponentLayout.module.scss";

interface ThreeItemLayoutProps {
  topLeft: React.ReactNode;
  topRight: React.ReactNode;
  bottom: React.ReactNode;
  horizontalGap?: number;
  verticalGap?: number;
  topLeftWidthPercent?: number;
  topRowHeightPercent?: number;
}

const ThreeComponentLayout: React.FC<ThreeItemLayoutProps> = ({
  topLeft,
  topRight,
  bottom,
  horizontalGap = 16,
  verticalGap = 16,
  topLeftWidthPercent = 50,
  topRowHeightPercent,
}) => {
  const safeWidthPercent = Math.max(0, Math.min(100, topLeftWidthPercent));
  const topLeftSpan = Math.round((safeWidthPercent / 100) * 24);
  const topRightSpan = 24 - topLeftSpan;

  const TopRow = (
    <Row gutter={horizontalGap} className={styles.fullHeight}>
      <Col xs={24} md={topLeftSpan} className={styles.fullHeight}>
        {topLeft}
      </Col>
      <Col xs={24} md={topRightSpan} className={styles.fullHeight}>
        {topRight}
      </Col>
    </Row>
  );

  const BottomRow = (
    <Row className={styles.fullHeight}>
      <Col span={24} className={styles.fullHeight}>
        {bottom}
      </Col>
    </Row>
  );

  if (topRowHeightPercent != null) {
    const safeHeightPercent = Math.max(0, Math.min(100, topRowHeightPercent));

    const layoutStyles = {
      "--vertical-gap": `${verticalGap}px`,
      "--top-row-flex-basis": `${safeHeightPercent}%`,
    } as React.CSSProperties;

    return (
      <div className={styles.layoutContainer} style={layoutStyles}>
        <div className={styles.topRowWrapper}>{TopRow}</div>
        <div className={styles.bottomRowWrapper}>{BottomRow}</div>
      </div>
    );
  }

  return (
    <div style={{ "--vertical-gap": `${verticalGap}px` }}>
      <div className={styles.topRowNoHeight}>{TopRow}</div>
      {BottomRow}
    </div>
  );
};

export default ThreeComponentLayout;
